// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Thorchain Unchained API
 * Provides access to thorchain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about the affiliate revenue earned
 * @export
 * @interface AffiliateRevenue
 */
export interface AffiliateRevenue {
    /**
     * Affiliate addresses
     * @type {Array<string>}
     * @memberof AffiliateRevenue
     */
    addresses: Array<string>;
    /**
     * Amount earned (RUNE)
     * @type {string}
     * @memberof AffiliateRevenue
     */
    amount: string;
    /**
     * Revenue earned by denom
     * @type {{ [key: string]: string; }}
     * @memberof AffiliateRevenue
     */
    revenue: { [key: string]: string; };
}

/**
 * Check if a given object implements the AffiliateRevenue interface.
 */
export function instanceOfAffiliateRevenue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "addresses" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "revenue" in value;

    return isInstance;
}

export function AffiliateRevenueFromJSON(json: any): AffiliateRevenue {
    return AffiliateRevenueFromJSONTyped(json, false);
}

export function AffiliateRevenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateRevenue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addresses': json['addresses'],
        'amount': json['amount'],
        'revenue': json['revenue'],
    };
}

export function AffiliateRevenueToJSON(value?: AffiliateRevenue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addresses': value.addresses,
        'amount': value.amount,
        'revenue': value.revenue,
    };
}

